import {
    FEATURE_VIEWER_CLOSE,
    FEATURE_VIEWER_SET_LOADING,
    FEATURE_VIEWER_LOADED,
    FEATURE_VIEWER_LOAD_ERROR
} from './FeatureViewerActions';
import { mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            options: {},
        }
    },
    computed: {
        ...mapGetters({
            loading: 'featureViewerLoading',
            loadingError: 'featureViewerLoadingError',
            result: 'featureViewerResult',
        }),
        viewerData() {
            if(!this.result){
                return [];
            }
            return this.result;
        },
        errorMsg() {
            let defaultError = 'Erro';
            return this.loadingError ?
                (this.loadingError.error && this.loadingError.error.error ?
                    this.loadingError.error.error : (this.loadingError.error ? this.loadingError.error : defaultError)) : defaultError;
        },
    },
    methods: {
        dispatchFeatureViewerAction(params){
            this.$store.dispatch('featureViewerAction', params);
        },
        setLoading(loading = false) {
            this.dispatchFeatureViewerAction({
                type: FEATURE_VIEWER_SET_LOADING,
                loading
            });
        },
        featureViewerClose() {
            this.dispatchFeatureViewerAction({
                type: FEATURE_VIEWER_CLOSE
            });
        },
        recordSearch({ url, options={} }) {
            return new Promise((resolve, reject) => {
                this.setLoading(true);
                resolve(this.loadData(url));
            })
            .then((result) => {
                if (result.error) {
                    this.recordsLoadError(result);
                }else{
                    return this.recordsLoaded({
                        url,
                    }, result);
                }
            })
            .catch((e) => {
                this.recordsLoadError(e);
            });
        },
        recordsLoaded(options, result) {
            this.dispatchFeatureViewerAction({
                type: FEATURE_VIEWER_LOADED,
                options: options,
                result: result
            });
        },
        recordsLoadError(e) {
            this.dispatchFeatureViewerAction({
                type: FEATURE_VIEWER_LOAD_ERROR,
                error: e
            });
        },
        recordsNotFound(records = "") {
            return {
                title: "Error",
                message: "Some records have not been found: {records} Please check the query param url",
                values: {records}
            };
        },
        async loadData(url) {
            return await this.$http.get(url)
            .then(res => {
                let data = res.data && res.data.data ? res.data.data : res.data;
                return data;
            })
            .catch(error => {
                return null;
            })
            .finally(()=> {

            })
        }
    },
};